/* eslint-disable */
export const maxLifetime = 38

export default [
[ 0, 3936 ],
[ 1, 2613 ],
[ 2, 2023 ],
[ 3, 1677 ],
[ 4, 1358 ],
[ 5, 1163 ],
[ 6, 978 ],
[ 7, 877 ],
[ 8, 765 ],
[ 9, 650 ],
[ 10, 570 ],
[ 11, 415 ],
[ 12, 360 ],
[ 13, 278 ],
[ 14, 201 ],
[ 15, 169 ],
[ 16, 104 ],
[ 17, 71 ],
[ 18, 48 ],
[ 19, 31 ],
[ 20, 22 ],
[ 21, 9 ],
[ 22, 3 ],
[ 23, 0 ]
]
